import { Orb, type OrbProps } from "./Orb";
import { clsx } from "clsx";

type OrbSize = "default" | "small";

const textModeScaleClassNames = {
  default: "tw-scale-[0.15625]",
  small: "tw-scale-[0.2]",
} satisfies Record<OrbSize, string>;

const orbContainerClassNames = {
  default: "tw-top-0 tw-left-0 tw-w-full",
  small: "tw-w-[12.5rem] tw-top-1/2 tw-left-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2",
} satisfies Record<OrbSize, string>;

export function OrbDisc({
  mode = "voice",
  orbSize = "default",
  ringClassName,
  ...orbProps
}: OrbProps & {
  mode?: "voice" | "text";
  orbSize?: OrbSize;
  ringClassName?: string;
}) {
  return (
    <div className='tw-absolute tw-inset-0 tw-z-20 tw-pointer-events-none'>
      <div
        className={clsx(
          "tw-relative tw-mx-auto tw-max-w-full tw-aspect-square tw-transition tw-duration-[400ms] tw-ease-in-out tw-origin-top tw-w-64",
          mode === "text" && "sm:tw-rotate-90",
        )}
      >
        <div
          className={clsx(
            "tw-absolute tw-inset-0 tw-transition tw-duration-[400ms] tw-ease-in-out tw-rounded-full tw-overflow-hidden tw-origin-top sm:tw-origin-center",

            mode === "text" && [
              textModeScaleClassNames[orbSize],
              "sm:-tw-rotate-90 sm:tw-translate-x-5 sm:-tw-translate-y-1",
            ],
          )}
        >
          <div className={clsx("tw-absolute tw-aspect-square", orbContainerClassNames[orbSize])}>
            <div className='tw-absolute tw-inset-0 tw-rounded-full tw-overflow-hidden'>
              <Orb {...orbProps} />
              <div className='tw-absolute tw-inset-0 tw-rounded-full tw-ring-0.5 tw-ring-inset tw-ring-black/7.5' />
              {ringClassName && <div className={clsx("tw-absolute tw-inset-0 tw-rounded-full", ringClassName)} />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
